// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xCoveoState } from "@eisinc/App/CoveoConnector/Store/Reducers";
import { getFacetData, getQueryFromUrl } from "@eisinc/App/CoveoConnector/Store/Selectors/CoveoSelectors";
import { SearchEventRequest } from "@eisinc/App/CoveoConnector/Types/schema";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchSetFilterQuery,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";

/**
 * Prepare facetDeselect event parameter
 * and store it in redux
 * so in the next get products call
 * we can fire this event
 * we can't call it here because we need the product total item count and response time
 * which we don't have them here
 * @param props 
 */
const CoveoPrepareFacetDeselectEventParameter: typeof DispatchSetFilterQuery = props => {
    const state = props.getState() as xCoveoState;
    const pagination = getProductListDataViewProperty(state, "pagination");
    const attributeTypeFacets = getProductListDataViewProperty(state, "attributeTypeFacets");
    const categoryFacets = getProductListDataViewProperty(state, "categoryFacets");
    const productLineFacets = getProductListDataViewProperty(state, "productLineFacets");
    const brandFacets = getProductListDataViewProperty(state, "brandFacets");

    if (state.xCoveo.trackCoveo) {
        const customData = getFacetData(props, attributeTypeFacets, categoryFacets, productLineFacets, brandFacets);

        const facetDeselectEventParameter: SearchEventRequest = {
            actionCause: "facetDeselect",
            numberOfResults: pagination?.totalItemCount || 0,
            queryText: getQueryFromUrl(state).query || "",
            responseTime: 0,
            searchQueryUid: translate("my-uid"),
            originLevel1: "listing",
            searchHub: "listing",
            customData,
        };
        
        props.dispatch({
            type: "xCoveo/setLastFacetDeSelectEvent",
            lastFacetDeSelectEvent: facetDeselectEventParameter,
        } as any);
    }
};

addToEndOfChain(chain, CoveoPrepareFacetDeselectEventParameter);
